import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postRuleset = async ({ payload }) => {
  const { data } = await SigliveServiceV1({ method: 'POST', url: `/schedule-ruleset`, data: payload });

  return data?.data;
};

export default postRuleset;
